import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types/params";

const endpoint = {
  plans: "/subscriptions",
};

export const fetchPlans = createAsyncThunk(
  "planSubscription/fetchPlans",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.plans, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createPlans = createAsyncThunk(
  "planSubscription/createPlans",
  async (data: any, thunkAPI) => {
    try {
      const isFormData =
        typeof FormData !== "undefined" && data instanceof FormData;
      const response = await axiosInstance.post(endpoint.plans, data, {
        headers: isFormData
          ? { "Content-Type": "multipart/form-data" }
          : undefined,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updatePlans = createAsyncThunk(
  "planSubscription/updatePlans",
  async (data: any, thunkAPI) => {
    try {
      const { id, ...rest } = data;
      const payload = (rest as any).data ? (rest as any).data : rest;
      const isFormData =
        typeof FormData !== "undefined" && payload instanceof FormData;
      const url = isFormData
        ? `${endpoint.plans}/${id}?_method=PUT`
        : `${endpoint.plans}/${id}`;
      const method = isFormData ? "post" : "put";
      // @ts-ignore
      const response = await axiosInstance[method](url, payload, {
        headers: isFormData
          ? { "Content-Type": "multipart/form-data" }
          : undefined,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deletePlans = createAsyncThunk(
  "planSubscription/deletePlans",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`${endpoint.plans}/${slug}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

// Toggle active/inactive for a plan subscription
export const togglePlanActive = createAsyncThunk(
  "planSubscription/togglePlanActive",
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(
        `${endpoint.plans}/${id}/toggle-active`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
